import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";

import useTable from "../useTable";
import Controls from "../controls/Controls";

import { TableBody, TableRow, TableCell, InputAdornment } from "@mui/material";

import axios from "axios";
import {
  validaMonto,
  formatoMonto,
  validaSoloNumero,
  formatMoneda,
} from "../../util/varios";
import moment from "moment";

const AgregarRegistroInm = (props) => {
  /*  variables de estados */

  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const txtNumDoc = useRef();
  const txtFolio = useRef();
  const txtTomo = useRef();
  const txtProt = useRef();
  const txtAsiento = useRef();
  const txtFecha = useRef();
  const txtAreaTerr = useRef();
  const txtAreaCons = useRef();
  const txtMont = useRef();
  const btnCancela = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));

  const [values, setValues] = useState({
    numeroregistro: "",
    folio: "",
    areaconstruccion: "",
    tomo: "",
    protocolo: "",
    asientoregistral: "",
    fecharegistro: "",
    valorinmueble: "",
  });
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState("0");
  const [operacionFicha, setOperacionFicha] = useState("0");

  const blanquear = () => {
    setValues({
      numeroregistro: "",
      folio: "",
      areaconstruccion: "",
      tomo: "",
      protocolo: "",
      asientoregistral: "",
      fecharegistro: "",
      valorinmueble: "",
    });
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancela();
  };

  const handleCloseMensa = () => {
    setMostrar(false);
    /*         seleccionarActividadesTodas(props.anio ? props.anio : localStorage.getItem("efiscalanio")); */
  };

  const cancelar = () => {
    /*   if (operacionFicha === 2 || operacionFicha === 3) {
            props.agregarDetalle(values)
        } else { */
    props.onHideCancela();
    /*     } */

    blanquear();
  };

  const onChange = (e) => {
    e.preventDefault();
    if (e.target.type === "text" || e.target.type === "textarea") {
      e.target.value = e.target.value.toUpperCase();
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };

  const procesarDetalles = () => {
    let endpoint = `${op.conexion}/api/inmueble/registrardetallesreg`;
    let body;
    setActivate(true);

    body = {
      operacion: operacion,
      nid: values?.iddetalleregistro,
      idInmue: props.idinmueble,
      numreg: values?.numeroregistro,
      cfolio: values?.folio,
      ctomo: values?.tomo,
      cproto: values?.protocolo,
      fecteg: txtFecha?.current?.value,
      terre: txtAreaTerr?.current?.value.replace(/\./g, "").replace(",", "."),
      constru: txtAreaCons?.current?.value.replace(/\./g, "").replace(",", "."),
      valor: txtMont?.current?.value.replace(/\./g, "").replace(",", "."),
      casientreg: values?.asientoregistral,
    };

    // console.log(body)

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Registrada Exitosamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Modificada Exitosamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Eliminada Exitosamente",
              icono: "exito",
            });
          }

          props.renderDetalles(props.idinmueble);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    if (operacion === 3) {
      procesarDetalles();
      blanquear();
      return;
    } else if (parseInt(operacionFicha) === 1) {
      if (txtNumDoc.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar un N° Documento Válido",
          icono: "informacion",
        });
        txtNumDoc.current.focus();
        return;
      } else if (txtAreaTerr.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar un Area de Terreno Válido",
          icono: "informacion",
        });
        txtAreaTerr.current.focus();
        return;
      } else if (txtAreaCons.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar un Area de Construccion Válido",
          icono: "informacion",
        });
        txtAreaCons.current.focus();
        return;
      } else if (txtMont.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar un Monto Válido",
          icono: "informacion",
        });
        txtMont.current.focus();
        return;
      }
      console.log(txtNumDoc.current.value);
      console.log(txtMont.current.value);
      console.log(txtAreaTerr.current.value);
      console.log(txtAreaCons.current.value);
      console.log(operacion);
      let arrays = {
        numeroregistro: values?.numeroregistro || "",
        areaterreno: txtAreaTerr.current.value
          ? txtAreaTerr.current.value.replace(/\./g, "").replace(",", ".")
          : "",
        folio: values?.folio || "",
        areaconstruccion: txtAreaCons.current.value
          ? txtAreaCons.current.value.replace(/\./g, "").replace(",", ".")
          : "",
        tomo: values?.tomo || "",
        protocolo: values?.protocolo || "",
        asientoregistral: values?.asientoregistral || "",
        fecharegistro: values?.fecharegistro || "",
        valorinmueble: txtMont.current.value
          ? txtMont.current.value.replace(/\./g, "").replace(",", ".")
          : "",
      };

      props.agregarDetalle(arrays);
      blanquear();
    } else {
      procesarDetalles();
      // console.log('otra ficha');
      /**/
    }
    // let sigue = true;

    // if (txtNumDoc.current.value === "") {
    //   setMensaje({
    //     mostrar: true,
    //     titulo: "Notificación",
    //     texto: "Debe ingresar correctamente todos los datos",
    //     icono: "informacion",
    //   });
    //   sigue = false;
    //   txtNumDoc.current.focus();
    // } else if (txtFolio.current.value === "") {
    //   setMensaje({
    //     mostrar: true,
    //     titulo: "Notificación",
    //     texto: "Debe ingresar correctamente todos los datos",
    //     icono: "informacion",
    //   });
    //   sigue = false;
    //   txtFolio.current.focus();
    // } else if (txtTomo.current.value === "") {
    //   setMensaje({
    //     mostrar: true,
    //     titulo: "Notificación",
    //     texto: "Debe ingresar correctamente todos los datos",
    //     icono: "informacion",
    //   });
    //   sigue = false;
    //   txtTomo.current.focus();
    // } else if (txtProt.current.value === "") {
    //   setMensaje({
    //     mostrar: true,
    //     titulo: "Notificación",
    //     texto: "Debe ingresar correctamente todos los datos",
    //     icono: "informacion",
    //   });
    //   sigue = false;
    //   txtProt.current.focus();
    // } else if (txtAsiento.current.value === "") {
    //   setMensaje({
    //     mostrar: true,
    //     titulo: "Notificación",
    //     texto: "Debe ingresar correctamente todos los datos",
    //     icono: "informacion",
    //   });
    //   sigue = false;
    //   txtAsiento.current.focus();
    // } else if (txtFecha.current.value === "") {
    //   setMensaje({
    //     mostrar: true,
    //     titulo: "Notificación",
    //     texto: "Debe ingresar correctamente todos los datos",
    //     icono: "informacion",
    //   });
    //   sigue = false;
    //   txtFecha.current.focus();
    // } else if (txtAreaTerr.current.value === "") {
    //   setMensaje({
    //     mostrar: true,
    //     titulo: "Notificación",
    //     texto: "Debe ingresar correctamente todos los datos",
    //     icono: "informacion",
    //   });
    //   sigue = false;
    //   txtAreaTerr.current.focus();
    // } else if (txtAreaCons.current.value === "") {
    //   setMensaje({
    //     mostrar: true,
    //     titulo: "Notificación",
    //     texto: "Debe ingresar correctamente todos los datos",
    //     icono: "informacion",
    //   });
    //   sigue = false;
    //   txtAreaCons.current.focus();
    // } else if (txtMont.current.value === "") {
    //   setMensaje({
    //     mostrar: true,
    //     titulo: "Notificación",
    //     texto: "Debe ingresar correctamente todos los datos",
    //     icono: "informacion",
    //   });
    //   sigue = false;
    //   txtMont.current.focus();
    // }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", "."),
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }

    // Devuelve el número formateado
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };

  // console.log(values)

  const handleInputNumChange = (event) => {
    //setActiveIndex(1);
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setOperacionFicha(props.operacionFicha);
        if (props.operacion !== 1) {
          setValues(props.detalle);
          txtFecha.current.value = moment
            .utc(props.detalle.fecharegistro)
            .format("YYYY-MM-DD");
        }
        // console.log(props.detalle)
      }}
    >
      <Modal.Header className="azulGradiant">
        <Modal.Title style={{ color: "#fff" }}>
          {operacion === 1
            ? "Agregar Registro Inmobiliario "
            : operacion === 2
              ? "Editar Registro Inmobiliario"
              : operacion === 3
                ? "Eliminar Registro Inmobiliario"
                : ""}{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <Dimmer active={activate} inverted></Dimmer>

        <div className="row col-md-12 mx-auto px-0">
          <div className="input-group input-group-sm mb-2 col-md-4">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              N° Documento:
            </span>
            <input
              type="text"
              ref={txtNumDoc}
              disabled={operacion === 3}
              className="form-control text-uppercase"
              aria-label="Sizing example input text-right"
              aria-describedby="inputGroup-sizing-sm"
              onKeyUp={handleInputNumChange}
              onBlur={handleInputNumChange}
              name="numeroregistro"
              value={
                values && values.numeroregistro != ""
                  ? values.numeroregistro
                  : ""
              }
              onChange={onChange}
            />
          </div>

          <div className="col-md-4"></div>

          <div className="input-group input-group-sm mb-2 col-md-4">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Fecha:
            </span>
            <input
              type="date"
              ref={txtFecha}
              disabled={operacion === 3}
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              name="fecharegistro"
              defaultValue={
                values && values.fecharegistro
                  ? moment.utc(values.fecharegistro).format("YYYY-MM-DD")
                  : moment.utc(fechasistema).format("YYYY-MM-DD")
              }
              onChange={onChange}
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-4 mx-auto">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Folio:
            </span>
            <input
              type="text"
              disabled={operacion === 3}
              ref={txtFolio}
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              name="folio"
              value={values && values.folio != "" ? values.folio.trim() : ""}
              onChange={onChange}
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-4 mx-auto">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Tomo:
            </span>
            <input
              type="text"
              disabled={operacion === 3}
              ref={txtTomo}
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              name="tomo"
              value={values && values.tomo != "" ? values.tomo.trim() : ""}
              onChange={onChange}
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-4 mx-auto">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Protocolo:
            </span>
            <input
              type="text"
              disabled={operacion === 3}
              ref={txtProt}
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              name="protocolo"
              value={
                values && values.protocolo != "" ? values.protocolo.trim() : ""
              }
              onChange={onChange}
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-12">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Asiento Registral:
            </span>
            <textarea
              type="textarea"
              ref={txtAsiento}
              disabled={operacion === 3}
              style={{ height: 70 }}
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              name="asientoregistral"
              value={
                values && values?.asientoregistral
                  ? values?.asientoregistral.trim()
                  : ""
              }
              onChange={onChange}
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-4">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Area Terreno:
            </span>
            <input
              type="text"
              ref={txtAreaTerr}
              disabled={operacion === 3}
              className="form-control text-right"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
              name="areaterreno"
              defaultValue={
                values && values.areaterreno
                  ? values.areaterreno != ""
                    ? formatMoneda(
                        values.areaterreno.toString().replace(".", ","),
                        ",",
                        ".",
                        2,
                      )
                    : ""
                  : ""
              }
              onChange={onChange}
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-4">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Area Construcción:
            </span>
            <input
              type="text"
              ref={txtAreaCons}
              disabled={operacion === 3}
              className="form-control text-right"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
              name="areaconstruccion"
              defaultValue={
                values && values.areaconstruccion != ""
                  ? formatMoneda(
                      values.areaconstruccion.toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )
                  : ""
              }
              onChange={onChange}
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-4">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Monto:
            </span>
            <input
              type="text"
              ref={txtMont}
              disabled={operacion === 3}
              className="form-control text-right"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
              name="valorinmueble"
              defaultValue={
                values && values.valorinmueble != ""
                  ? formatMoneda(
                      values.valorinmueble.toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )
                  : ""
              }
              onChange={onChange}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          onClick={onChangeValidar}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>

        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill"
        >
          <i className="fa"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AgregarRegistroInm;
